interface Props {
  className?: string;
}

export const GsShield = ({ className }: Props) => (
  <svg
    viewBox="0 0 48 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Golden State Project Works shield logo"
    className={className}
  >
    <defs>
      <linearGradient id="gsShieldGrad" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="hsl(42 70% 62%)" />
        <stop offset="100%" stopColor="hsl(36 55% 38%)" />
      </linearGradient>
    </defs>
    <path
      d="M24 1.5 L45 8 V27 C45 41 35.5 50 24 54.5 C12.5 50 3 41 3 27 V8 Z"
      fill="hsl(0 0% 6%)"
      stroke="url(#gsShieldGrad)"
      strokeWidth="1.5"
    />
    <text
      x="24"
      y="33"
      textAnchor="middle"
      fontFamily="Oswald, sans-serif"
      fontWeight="700"
      fontSize="18"
      fill="url(#gsShieldGrad)"
      letterSpacing="0.5"
    >
      GS
    </text>
  </svg>
);
